export const ESTIMATES = "My Quotes";
export const CREATE = "New Quote";
export const ESTIMATE_ITEMS = "Quote Items";
export const SETTINGS = "Settings";
